<template>
        <div class="body-inner">
            <!-- Section -->
            <section class="fullscreen" style="background-image: url(/assets/images/store-bg.jpg)">
                <div class="container container-fullscreen">
                    <div class="text-middle">
                        <div class="text-center m-b-30">
                            <a href="index.html" class="logo">
                                <img src="/assets/images/main_logo.png" alt=" ">
                            </a>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 center p-40 background-white b-r-6">
                                <form class="form-transparent-grey">
                                    <vue-form :state="formstate" @submit.prevent="create()">                                    
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h3>Registrar nueva cuenta</h3>
                                                <p>Por favor complete los campos</p>
                                            </div>
                                            
                                            <div class="col-lg-12 form-group">
                                                <validate tag="div">
                                                    <label class="sr-only">Nombre</label>
                                                    <input type="text" class="form-control" id="nombres" v-model="model.nombre" name="nombres" placeholder="Escribe tu nombre" required>
                                                    <field-messages name="nombres" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">El nombre es requerido</div>
                                                    </field-messages>
                                                </validate>
                                            </div>

                                            <div class="col-lg-12 form-group">
                                                <validate tag="div">
                                                    <label class="sr-only">Apellido</label>
                                                    <input type="text" class="form-control" name="apellidos" id="apellidos" v-model="model.apellidos" placeholder="Apellidos" required>
                                                    <field-messages name="apellidos" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">Los apellidos son requeridos</div>
                                                    </field-messages>
                                                </validate>
                                            </div>

                                            <div class="col-lg-12 form-group">
                                                <validate tag="div">
                                                    <label class="sr-only">Correo electrónico</label>
                                                    <input class="form-control" id="email" name="email" v-model="model.email" placeholder="Dirección de correo válida" type="email" required >
                                                    <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">El correo electrónico es requerido</div>
                                                        <div slot="email">El correo electrónico no es válido</div>
                                                    </field-messages>
                                                </validate>
                                            </div>

                                            <div class="col-lg-12 form-group">
                                                <validate tag="div">
                                                    <label class="sr-only">Contraseña</label>
                                                    <input class="form-control" id="password" name="password" v-model="model.password" placeholder="Contraseña" type="password" required minlength="8">
                                                    <field-messages name="password" show="$invalid && $submitted" class="text-danger">
                                                        <div slot="required">La contraseña es requerida</div>
                                                        <div slot="minlength">La contraseña debe de tener mínimo 8 caracteres</div>
                                                    </field-messages>
                                                </validate>
                                            </div>
                                            <div class="col-lg-12 form-group">
                                                <label class="sr-only">Teléfono</label>
                                                <input type="text" value="" placeholder="Teléfono" class="form-control">
                                            </div>
                                            <div class="col-lg-12 form-group">
                                                <button type="submit" class="btn">Registrar cuenta </button>
                                                <p>Ya tengo cuenta. <router-link to="/" class="a-link ml-2">Ingresar</router-link> 
                                                </p>
                                            </div>
                                        </div>
                                    </vue-form>                                        
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- end: Section -->
        </div>
</template>
<script>
    import options from '../validations/validations.js'
    Vue.use(VueForm, options)
	export default {
		name: 'Register',
        components: {
            flatPickr
        },
        data() {
            return {
                paises: [],
                idiomas: [],
                estados: [],
                ciudades: [],
                zonashorarias: [],
                clients: [],
                tipoUsuarios: [{id: 1, nombre: 'Estudiante'}, {id: 2, nombre: 'Maestro'}],
                formstate: {},
                classNavbar: 'navbar navbar-top navbar-expand navbar-light bg-gradient-light border-bottom',
                model: {
                    nombre: '',
                    apellidos: '',
                    email: '',
                    password: '',
                    id_pais: '1',
                    id_idioma: '2',
                    id_estado: '1',
                    id_ciudad: '1714',
                    id_cliente: "27",
                    id_zona_horaria: '1',
                    fecha_nacimiento: '1984-04-05',
                    tipo_usuario: {id: '4'},
                    tipo_usuario_pro: '1',
                    codigo_docente: '',
                },
            }
        },
        methods: {
            async create() {
                if (this.formstate.$invalid) {
                    return;
                } else {
                    let urlReturn = '/'
                    if(this.$store.state.carrito.productos.length > 0)
                        urlReturn = '/checkout'
                    this.model.id_idioma = {id: this.model.id_idioma}
                    this.model.id_pais = {id: this.model.id_pais}
                    this.model.id_estado = {id: this.model.id_estado}
                    this.model.id_ciudad = {id: this.model.id_ciudad}
                    this.model.id_zona_horaria = {id: this.model.id_zona_horaria}
                    this.model.id_cliente = {id: this.model.id_cliente}
                    const responseRegister = await this.register('api/usuarios', this.model, '', '', null, 0, 1, null)
                }
            }
        },
		async mounted() {

		}
	}
</script>
<style scoped>
	@import '../assets/css/plugins.css';
	@import '../assets/css/style.css';
  
</style>